import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import {
    BoardAuditRow, BoardRequest, DashboardDefault, DefaultTargets, DefaultAuditRow, DefaultRequest, ManagedBoard, ManagedPerson,
} from '../interfaces/managedDashboard.interface';

const h = () => ({ headers: AuthService.getAuthHeader() });
const E = ENDPOINTS.DASHBOARD_LAYOUTS;

export const ManagedDashboardService = {
    people: async (institutionId: string): Promise<ManagedPerson[]> =>
        (await axios.get(E.PEOPLE(institutionId), h())).data,

    targets: async (institutionId: string): Promise<DefaultTargets> =>
        (await axios.get(E.TARGETS(institutionId), h())).data,

    getBoard: async (institutionId: string, userId: string, boardKey = 'home'): Promise<ManagedBoard> =>
        (await axios.get(E.USER_BOARD(institutionId, userId, boardKey), h())).data,

    setBoard: async (institutionId: string, userId: string, boardKey: string, body: BoardRequest): Promise<ManagedBoard> =>
        (await axios.put(E.USER_BOARD(institutionId, userId, boardKey), body, h())).data,

    /** "Reset to role default": clears the person's board so the layout chain applies again. */
    clearBoard: async (institutionId: string, userId: string, boardKey = 'home'): Promise<ManagedBoard> =>
        (await axios.delete(E.USER_BOARD(institutionId, userId, boardKey), h())).data,

    boardAudit: async (institutionId: string, userId: string): Promise<BoardAuditRow[]> =>
        (await axios.get(E.USER_AUDIT(institutionId, userId), h())).data,

    listDefaults: async (institutionId: string, boardKey = 'home'): Promise<DashboardDefault[]> =>
        (await axios.get(E.DEFAULTS(institutionId, boardKey), h())).data,

    saveDefault: async (institutionId: string, body: DefaultRequest): Promise<DashboardDefault> =>
        (await axios.put(E.DEFAULTS_UPSERT(institutionId), body, h())).data,

    deleteDefault: async (id: string): Promise<void> => { await axios.delete(E.DEFAULT_BY_ID(id), h()); },

    defaultsAudit: async (institutionId: string): Promise<DefaultAuditRow[]> =>
        (await axios.get(E.DEFAULTS_AUDIT(institutionId), h())).data,
};
